
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useSelector, useDispatch } from 'react-redux'

import history from '../../Helpers/History'

import SessionActions from '../../Redux/Actions/SessionActions'

import AuthLayout from '../../Layouts/AuthLayout/AuthLayout'
import useTranslation from '../../Hooks/UseTranslation'

import TopLoader from '../../Components/TopLoader/TopLoader'

import '../LoginPage/LoginPage.scss'
import '../ForgotPage/ForgotPage.scss'
import './ResetPage.scss'

const ResetPage = (props: any) => {

    const { t } = useTranslation()

    const token = new URLSearchParams(props.location.search).get('token')

    const resetPasswordStatus = useSelector((state: any) => state.SessionReducer.resetPasswordStatus)
    const dispatch = useDispatch()

    const [ new_pass, setNewPass ] = useState('')
    const [ new_pass2, setNewPass2 ] = useState('')
    const [ showPassword, setShowPassword ] = useState(false)

    const resetPassword = () => {

        const data: any = {
            token,
            new_pass
        }

        dispatch(SessionActions.resetPasswordAction(data))
    }

    if (resetPasswordStatus === 'resetted') {

        Swal.fire({
            title: t('RESET_PASSWORD:SuccessModal-title'),
            text: t('RESET_PASSWORD:SuccessModal-content'),
            icon: 'success',
            confirmButtonText: t('RESET_PASSWORD:SuccessModal-button'),
            width: '500px',
            onClose: () => history.push('/login')
        })
    }

    return (
        <AuthLayout className="pl4-auth-layout--login pl4-auth-layout--forgot">
            <main className="pl4-login-page pl4-forgot-page pl4-reset-page">
                <section className="pl4-login-showcase pl4-reset-showcase" aria-hidden="true">
                    <div className="pl4-login-showcase__brand">
                        <img className="pl4-login-showcase__brand-icon" src="/svg-icons/logo-icon.svg" alt="" aria-hidden="true" />
                        <img className="pl4-login-showcase__brand-logo" src="/svg-icons/logo.svg" alt="PL4NNER" />
                    </div>

                    <div className="pl4-reset-showcase__visual">
                        <div className="pl4-reset-showcase__key">
                            <i className="fas fa-key" />
                        </div>

                        <small>{t('RESET_PASSWORD:Eyebrow')}</small>
                        <strong>{t('RESET_PASSWORD:ShowcaseTitle')}</strong>

                        <div className="pl4-reset-showcase__checks">
                            <span><i className="fas fa-check" /><em /></span>
                            <span><i className="fas fa-check" /><em /></span>
                            <span><i className="fas fa-check" /><em /></span>
                        </div>
                    </div>
                </section>

                <section className="pl4-login-panel pl4-forgot-panel">
                    <div className="pl4-login-form pl4-forgot-form">
                        <img className="pl4-login-form__logo" src="/images/logo.svg" alt="PL4NNER" />

                        <div className="pl4-forgot-heading-icon" aria-hidden="true">
                            <i className="fas fa-key" />
                        </div>

                        <div className="pl4-login-form__heading">
                            <span>{t('RESET_PASSWORD:Eyebrow')}</span>
                            <h1>{t('RESET_PASSWORD:Page-title')}</h1>
                            <p>{t('RESET_PASSWORD:Subtitle')}</p>
                        </div>

                        <form
                            noValidate
                            onSubmit={(event) => {
                                event.preventDefault()
                                resetPassword()
                            }}
                        >
                            <div className="pl4-login-field">
                                <label htmlFor="reset-password">{t('RESET_PASSWORD:PasswordLabel')}</label>
                                <div className="pl4-login-input">
                                    <i className="fas fa-lock" aria-hidden="true" />
                                    <input
                                        autoComplete="new-password"
                                        autoFocus
                                        id="reset-password"
                                        placeholder={t('RESET_PASSWORD:PasswordInput-Placeholder')}
                                        type={showPassword ? 'text' : 'password'}
                                        value={new_pass}
                                        onChange={(event) => setNewPass(event.target.value)}
                                    />
                                    <button
                                        aria-label={showPassword ? t('RESET_PASSWORD:HidePassword') : t('RESET_PASSWORD:ShowPassword')}
                                        className="pl4-login-input__toggle"
                                        type="button"
                                        onClick={() => setShowPassword((visible) => !visible)}
                                    >
                                        <i className={`far fa-eye${showPassword ? '-slash' : ''}`} aria-hidden="true" />
                                    </button>
                                </div>
                            </div>

                            <div className="pl4-login-field">
                                <label htmlFor="reset-password-confirm">{t('RESET_PASSWORD:ConfirmPasswordLabel')}</label>
                                <div className="pl4-login-input">
                                    <i className="fas fa-lock" aria-hidden="true" />
                                    <input
                                        autoComplete="new-password"
                                        id="reset-password-confirm"
                                        placeholder={t('RESET_PASSWORD:RePasswordInput-Placeholder')}
                                        type={showPassword ? 'text' : 'password'}
                                        value={new_pass2}
                                        onChange={(event) => setNewPass2(event.target.value)}
                                    />
                                </div>
                            </div>

                            <p className="pl4-forgot-help">
                                <i className="fas fa-shield-alt" aria-hidden="true" />
                                {t('RESET_PASSWORD:HelpText')}
                            </p>

                            <button
                                className="pl4-btn pl4-btn-primary pl4-login-submit"
                                disabled={resetPasswordStatus === 'resetting'}
                                type="submit"
                            >
                                {resetPasswordStatus === 'resetting' && (
                                    <i className="fas fa-circle-notch fa-spin" aria-hidden="true" />
                                )}
                                {t('RESET_PASSWORD:ButtonLabel')}
                            </button>

                            <Link className="pl4-forgot-back" to="/login">
                                <i className="fas fa-arrow-left" aria-hidden="true" />
                                {t('RESET_PASSWORD:LoginLink')}
                            </Link>
                        </form>
                    </div>
                </section>
            </main>

            <TopLoader show={resetPasswordStatus === 'resetting'} />
        </AuthLayout>
    )
}

export default ResetPage
